module.exports = __webpack_public_path__ + "static/media/Western.722022c6.svg";